import styled from 'styled-components';
import { colors } from 'globalStyles';


export const Wrapper = styled.div`
  width: 300px;

  > h1 {
    padding-top: 25px;
    color: ${colors.RED};
    font-size: 36px;
    line-height: 44px;
    margin: 0 0 11px
  }
`;

export const PadlockWrapper = styled.div`
text-align: center;
`

export const Text = styled.p`
  color: ${colors.BODY};
  margin: 10px 0 0;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  > a:hover {
    text-decoration: none;
  }
  > a {
    color: #007AFF !important;
    text-decoration: underline;
    display: inline-block;
  }
`;



// WEBPACK FOOTER //
// ./src/components/LoginErrorModal/styledComponents.js